import { Button } from "@alpacahq/ui/old";

import { useGetFPSLTierRates } from "~/v2/api/hooks/useGetFPSL";
import { FpslBenefits } from "./FpslBenefits";
import { FpslEliteDisclaimer } from "./FpslEliteDisclaimer";
import type { FPSLOnboardingProps } from "./index";

export const FpslStart = ({
  currentAccount,
  onNext,
  onBack,
}: FPSLOnboardingProps) => {
  const { eliteRate, defaultRate } = useGetFPSLTierRates({
    accountID: currentAccount?.id,
    product: "live",
  });

  return (
    <div className="flex h-full flex-col">
      <div className="flex grow flex-col gap-4">
        <FpslBenefits eliteRate={eliteRate}>
          <FpslEliteDisclaimer
            eliteRate={eliteRate}
            defaultRate={defaultRate}
          />
        </FpslBenefits>
      </div>

      {/* Action Buttons are pushed to the bottom */}
      <div className="mt-8 flex justify-between">
        <Button variant="v2/stroke" onClick={onBack}>
          Back
        </Button>
        <Button variant="v2/filled" onClick={onNext}>
          Continue
        </Button>
      </div>
    </div>
  );
};
